import { BaixaCobranca } from './../../../model/baixa-cobranca.model';
import { Injectable } from "@angular/core";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError, map} from "rxjs/operators";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { Aviso } from 'src/app/model/aviso.model';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';
import {Estado} from '../../../model/estado.model';


@Injectable({
  providedIn: 'root'
})
export class TarefasLeilaoService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }
  protected getResourceURL(): string {
    return 'front/tarefas/leilao';
  }


  public simularBaixaLeilao(ideLeilao: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-baixa-leilao/${ideLeilao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }


  public simularAuditoriaBaixaLeilao(): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-auditoria-baixa-leilao/`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alteracaoEstadoLeilao(ideLeilao: number, estado: Estado): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/simular-estado-leilao/${ideLeilao}`, estado).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

}
